export default "__VITE_ASSET__Dsls2tqA__"